import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c9d920e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IntroPage-background" }
const _hoisted_2 = { class: "IntroPage-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "277",
    height: "10",
    viewBox: "0 0 277 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M168.889 10C166.154 10 164.444 8.37607 163.932 6.15385H161.197C160.684 8.37607 158.462 10 156.239 10H150.684C148.462 10 146.496 8.63248 145.726 6.15385H143.504C142.65 8.37607 140.769 10 138.547 10C136.325 10 134.359 8.37607 133.59 6.15385H131.368C130.513 8.63248 128.632 10 126.41 10H120.855C118.632 10 116.41 8.37607 115.897 6.15385H113.162C112.65 8.37607 110.94 10 108.205 10L1.96581 5.55556C1.11111 5.55556 0 5.55556 0 4.70085C0 4.18803 1.11111 3.84615 1.96581 3.84615L108.547 0C110.769 0 112.393 1.62393 112.991 3.33333H115.726C116.239 1.7094 117.949 0 121.026 0H126.325C129.06 0 130.769 1.62393 131.282 3.33333H133.504C134.017 1.11111 136.239 0 138.462 0C140.684 0 142.906 1.11111 143.419 3.33333H145.641C146.239 1.7094 147.863 0 150.598 0H155.812C158.889 0 160.513 1.62393 161.111 3.33333H163.846C164.359 1.7094 166.068 0 168.291 0L274.872 3.84615C275.726 3.84615 276.838 4.10256 276.838 4.70085C276.838 5.55556 275.726 5.55556 274.872 5.55556L168.889 10ZM234.786 5.04273C234.786 4.18803 233.675 3.93162 232.821 3.93162L168.889 2.30769C167.265 2.30769 166.154 3.4188 166.154 5.04273H234.786ZM159.487 5.04273C159.487 3.4188 157.863 1.7094 155.897 1.7094H150.684C149.06 1.7094 147.35 3.33333 147.35 5.04273H159.487ZM141.795 5.04273C141.795 2.82051 140.171 1.7094 138.462 1.7094C136.752 1.7094 135.128 2.82051 135.128 5.04273H141.795ZM129.573 5.04273C129.573 3.4188 127.949 1.7094 125.983 1.7094H120.684C119.06 1.7094 117.35 3.33333 117.35 5.04273H129.573ZM110.769 5.04273C110.769 3.4188 109.658 2.30769 108.034 2.30769L44.1026 3.93162C43.2479 3.93162 42.1368 4.18803 42.1368 5.04273H110.769Z",
      fill: "black"
    })
  ])
], -1))
const _hoisted_4 = { class: "stripe-title" }

import { onMounted, ref } from "vue";
import { gsap } from "gsap";
import Router from "@/core/Router";
import { playVideoTransition } from "@/store/modules/Video";
import Viewport from "@/store/modules/Viewport";
import { resolvePath } from "@/utils/Path";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroPage',
  setup(__props) {

const root = ref<HTMLElement>()

onMounted(() => {
  onEnter()
})

const onEnter = () => { 
  const tl = gsap.timeline({ delay: 0.5 })
  const $ = gsap.utils.selector(root.value)

  tl
    .from($('.poster-desktop'), {
      opacity: 0,
      scale: 2,
      rotate: -5,
      duration: 1.25,
      ease: 'quart.out',
      stagger: 0.25,
      clearProps: 'all'
    }, 0)
    .from($('.hr'), {
      scale: 0,
      transformOrigin: 'center center',
      duration: 1,
      ease: 'quart.out',
      clearProps: 'all'
    }, 0.75)
    .from($('.stripe-title'), {
      opacity: 0,
      scale: 0.75,
      duration: 1,
      ease: 'quart.out',
      clearProps: 'all'
    }, 0.5)
    .add(() => playVideoTransition(), 3)
    .add(() => Router.push('/home'), 5)
}

return (_ctx: any,_cache: any) => {
  const _component_ui_image = _resolveComponent("ui-image")!
  const _component_line_by_line = _resolveComponent("line-by-line")!

  return (_openBlock(), _createElementBlock("div", {
    class: "IntroPage h-full",
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(Viewport).isMobile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ui_image, {
              class: "poster-desktop poster-1",
              alt: "teaser",
              image: {
          url: _unref(resolvePath)(require('@/assets/img/intro/global-poster-1.webp')),
          double: _unref(resolvePath)(require('@/assets/img/intro/global-poster-1@2x.webp'))
        }
            }, null, 8, ["image"]),
            _createVNode(_component_ui_image, {
              class: "poster-desktop poster-2",
              alt: "teaser",
              image: {
          url: _unref(resolvePath)(require('@/assets/img/intro/global-poster-2.webp')),
          double: _unref(resolvePath)(require('@/assets/img/intro/global-poster-2@2x.webp'))
        }
            }, null, 8, ["image"]),
            _createVNode(_component_ui_image, {
              class: "poster-desktop poster-3",
              alt: "teaser",
              image: {
          url: _unref(resolvePath)(require('@/assets/img/intro/global-poster-3.webp')),
          double: _unref(resolvePath)(require('@/assets/img/intro/global-poster-3@2x.webp'))
        }
            }, null, 8, ["image"])
          ], 64))
        : (_openBlock(), _createBlock(_component_ui_image, {
            key: 1,
            alt: "teaser",
            image: {
          url: _unref(resolvePath)(require('@/assets/img/intro/poster-mobile.png')),
          double: _unref(resolvePath)(require('@/assets/img/intro/poster-mobile@2x.png'))
        }
          }, null, 8, ["image"]))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_line_by_line, {
        tag: "h1",
        class: "h1",
        delay: 0.5
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('intro.first_title')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("h1", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (idx) => {
          return _createElementVNode("span", { key: idx }, _toDisplayString(_ctx.$t('intro.wanted_poster')), 1)
        }), 64))
      ]),
      _createVNode(_component_line_by_line, {
        tag: "h1",
        class: "h1",
        delay: 1.25,
        innerHTML: _ctx.$t('intro.second_title')
      }, null, 8, ["innerHTML"])
    ])
  ], 512))
}
}

})